<template>
  <v-main class="mt-12">
    <div class="close d-flex flex-row align-center pt-2 pb-6 ml-4 ml-md-0" @click="backToOrigin">
      <img :src="closeIcon" class="icon mr-4"/><span class="label">{{ $t('page.go_back_to_search') }}</span>
    </div>
    <v-row>
      <v-col cols="12">
        <div class="text-left my-0 pl-6 pl-md-0 top">
          {{ $t('cart.selected_packages') }} ({{cart_size}})
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="8">
        <cart-component @price-change="price_change($event)"></cart-component>
      </v-col>
      <v-col cols="12" md="4" class="px-md-3 px-0">
        <order-summary-component
          :cart_size="cart_size"
          :value="value"
          :discount-items="discount_items"
          :booking-callback="goToReservationNextStep"
        ></order-summary-component>
      </v-col>
    </v-row>
  </v-main>
</template>

<script>
import { useStore } from "vuex";
import CartComponent from '../components/CartComponent.vue';
import OrderSummaryComponent from '../components/OrderSummaryComponent.vue';

export default {
  components: {
    CartComponent,
    OrderSummaryComponent
  },
  data() {
    return {
      value: 0,
      cart_size: 0,
      discount_items: [],
      closeIcon: require('../assets/icons/chevron-left.svg'),
      store: useStore()
    }
  },
  methods: {
    price_change(event) {
      this.value = event.value;
      this.cart_size = event.cart_size;
      this.discount_items = event.discount_items;
    },
    backToOrigin() {
        this.$router.push({name: 'resultsView'});
    },
    goToReservation() {
        this.$router.push({name: 'reservationView'})
        window.scrollTo({ top: 0, behavior: 'smooth'});
    },
    goToConfirmation() {
        this.$router.push({name: 'confirmationView'})
        window.scrollTo({ top: 0, behavior: 'smooth'});
    },
    goToReservationNextStep() {
        if (!this.store.getters["phenotypeModule/hasPhenotypeMode"]('own')) {
          this.$router.push({name: 'reservationPhenotypeView', params: { type: 'own'}})
        } else if (!this.store.getters["phenotypeModule/hasPhenotypeMode"]('partner')) {
          this.$router.push({name: 'reservationPhenotypeView', params: { type: 'partner'}})
        } else {
          this.$router.push({name: 'confirmationView'})
        }
        window.scrollTo({ top: 0, behavior: 'smooth'});
    }
  }
}

</script>

<style lang="scss" scoped>
  .top {
    @include nsb-gentium-bold;
    font-size: 28px;
    line-height: 33px;
    .counter {
      @include nsb-font-container;
      color: $nsb-color-4;
      font-size: 14px;
      line-height: 21px;
      letter-spacing: 0.3px;
    }
  }
  .close {
    cursor: pointer;
  }
</style>